import React, {useState} from 'react';
import localStrings from "../../../localStrings";
import BarTurnover from "../../../Graphs/BarTurnover";
import {Tab, Tabs} from "@mui/material";
import {filterOrderItemsWithProduct} from "../../../Graphs/BarGraphUtils";
import {byLocationMode, byProductMode, byStaffMode} from "../../../Graphs/constants";
import OptionListsDetail from "./OptionListsDetail";

function ProductDetail({product, mapOptionOptionList, noPrice}) {
    const [currentTab, setCurrentTab] = useState('general');

    const handleTabsChange = (event, value) => {
        setCurrentTab(value);
    };

    return (
        <div style={{width: '100%'}}>
            <Tabs
                style={{marginLeft: '15px'}}
                onChange={handleTabsChange}
                scrollButtons="auto"
                value={currentTab}
                textColor="secondary"
                variant="scrollable"

            >
                <Tab label={localStrings.general} value="general" />
                <Tab label={localStrings.byStaff} value="byStaff" />
                <Tab label={localStrings.byLocation} value="byLocation" />
                <Tab label={localStrings.options} value="options" />
                {/*<Tab label={localStrings.updateWidgetData} value="updateWidgetData" />*/}
            </Tabs>
            <div style={{width: '100%'}}>
                {currentTab === 'general' &&
                    <BarTurnover
                        noPrice={noPrice}
                        displayMode={byProductMode}
                        title={localStrings.general}
                        product={product}
                    />
                }
                {currentTab === 'byStaff' &&
                    <BarTurnover
                        noPrice={noPrice}
                        displayMode={byStaffMode}
                        title={localStrings.byStaff}
                        product={product}
                        transformer={order => {
                            return filterOrderItemsWithProduct(order, product)
                        }}
                    />
                }
                {currentTab === 'byLocation' &&
                    <BarTurnover
                        noPrice={noPrice}
                        displayMode={byLocationMode}
                        title={localStrings.byLocation}
                        product={product}
                        transformer={order => {
                            return filterOrderItemsWithProduct(order, product)
                        }}
                    />
                }
                {currentTab === 'options' &&
                    <OptionListsDetail
                        mapOptionOptionList={mapOptionOptionList}
                        product={product}
                        // orders={orders.map(order => filterOrderItemsWithProduct(order, product)).filter(order => order != null)}
                    />
                }
            </div>
        </div>
    )
}

export default ProductDetail